import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from 'actions/types'

export const contactsContextCompanyContactsPivotTableKey = 'contactsContext.selected.companyContacts.pivotTable'

export const showDormants = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_COMPANY_CONTACTS_TOGGLE_DORMANTS:
      return action.showDormants
    default:
      return state
  }
}

const pivotTable = createPivotTableReducer({
  key: contactsContextCompanyContactsPivotTableKey,
  defaultSortColumn: 'forename,surname',
  defaultSortDirection: 'asc',
})

export default combineReducers({
  showDormants,
  pivotTable,
})
